<template>
  <div class="query-name text-sm lg:text-lg query-name text-white bg-black">
    <div class="" v-if="['EMAIL', 'TODO_EMAIL', 'DONE_EMAIL'].indexOf(prog) !== -1">
      <div class="pb-4 text-base font-bold">
        <span v-if="prog === 'TODO_EMAIL'" class="">Todo Email</span>
        <span v-else-if="prog === 'DONE_EMAIL'" class="">Done Email</span>
        <span v-else>Email Digest</span>
      </div>
      <div class="mb-4 rounded text-sm text-white bg-black">
        <div class="pb-2">
          <span v-if="prog === 'TODO_EMAIL'" class="todo">Todo</span>
          <span v-else-if="prog === 'DONE_EMAIL'" class="done">Done</span>
          <span v-else>All Notes</span>


          in <span class="font-bold font-mono path text-black bg-light-yellow">{{path}}</span>
        </div>
        <div v-if="tags && tags.length">With tags
          <span v-for="t in tags" class="tag font-bold font-mono mr-2" v-html="parsedSymbol(t)"></span>
        </div>
      </div>
      <div class="text-xs font-bold">
        <span v-if="schedule">{{schedule}}</span>
      </div>

    </div>
    <div v-else-if="prog === 'SMS'" class="">
      <div class="pb-4 text-base font-bold">Text Reminder</div>
      <div class="mb-4 text-white fon-bold rounded text-sm bg-black">{{text}}</div>
      <div class="text-xs font-bold">
        <span v-if="schedule">{{schedule}}</span>
      </div>
    </div>
    <div v-else-if="prog === 'REMINDER_EMAIL'" class="">
      <div class="pb-4 text-base font-bold">Email Reminder</div>
      <div class="mb-4 text-white fon-bold rounded text-sm bg-black">{{subject}}</div>
      <div class="mb-4 text-white fon-bold rounded text-sm bg-black">{{text}}</div>
      <div class="text-xs font-bold">
        <span v-if="schedule">{{schedule}}</span>
      </div>
    </div>

    <div v-else-if="prog === 'CONNECTION_SEND'" class="">
      <div v-if="connection" class="pb-4 text-base font-bold">
        Send to
        <span v-if="connection.type === 'SIGNAL'">Signal Number {{formatIntlNumber(connection.target)}}</span>
        <span v-if="connection.type === 'TELEGRAM'">Telegram Account @{{(connection.target_info.username)}}</span>
      </div>
      <div v-else class="pb-4 text-base font-bold">
        No connection selected...
      </div>

      <div class="mb-4 text-white fon-bold rounded text-sm bg-black" v-if="payload">{{payload.text}}</div>
      <div class="text-xs font-bold">
        <span v-if="schedule">{{schedule}}</span>
      </div>
    </div>

    <div v-else-if="prog === 'NOTE'" class="">
      <div class="pb-4 text-base font-bold">Repeating Note</div>
      <div class="w-full mb-4 border-white rounded">
        <div class="text-white text-sm pr-2 pb-2">Save</div>
        <div class="border-l-4 border-white text-white">
          <note
            :text="text"
            :item="{parsed: parseNote(text)}"
            class="text-sm"
          />
        </div>
      </div>
      <div class="text-xs font-bold">
        <span v-if="schedule">{{schedule}}</span>
      </div>
    </div>
  </div>
</template>

<script>
 import { parsePhoneNumberFromString } from 'libphonenumber-js';
 import {parse} from '@tatatap-com/sowhat'
 import {mapState} from 'vuex'
 import { DateTime } from 'luxon';
 import dlv from 'dlv';
 export default {
   props: {
     fn: {
       type: Object,
       required: true
     },
     frequency: {
       type: String,
       required: true
     },
     startDate: {
       type: String,
       default: ''
     }
   },
   computed: {
     ...mapState({
       connections: state => state.verifiedConnections
     }),

     connectionId () {
       const prog = this.fn.run[this.prog];
       return prog.connection_id
     },

     connection () {
       return this.connections.find(c => c.id === this.connectionId)
     },

     prog () {
       return Object.keys(this.fn.run)[0];
     },

     text () {
       const prog = this.fn.run[this.prog];

       if (typeof prog === 'string') {
         return prog;
       }

       return prog.text
     },

     subject () {
       const prog = this.fn.run[this.prog];
       return prog.subject
     },

     payload () {
       const prog = this.fn.run[this.prog];
       return prog.payload
     },

     query () {
       return dlv(this.fn, 'run.EMAIL.query.records') ||
              dlv(this.fn, 'run.TODO_EMAIL.query.records') ||
              dlv(this.fn, 'run.DONE_EMAIL.query.records');
     },

     path () {
       if (!this.query) {
         return ''
       }

       const p = this.query.AND.find(c => c.entity === 'PATH') || {};

       return p.term || '/';
     },

     tags () {
       if (!this.query) {
         return []
       }

       const t = this.query.AND.find(c => c.entity === 'TAG') || {};

       return (t.term || []).map(t => '#' + t);
     },

     type () {
       if (!this.query) {
         return ''
       }

       const t = this.query.AND.find(c => c.entity === 'TODO') || {};

       return t.term || 'all';
     },

     schedule () {
       const date = DateTime.fromISO(this.startDate)

       if (date.invalid) {
         return ''
       }

       return ({
         DAILY: () => `Daily at ${date.toFormat('t')}`,
         // WEEK: () => `on weekdays at ${date.toFormat('t')}`,
         WEEKLY: () => `Weekly on ${date.toFormat("cccc 'at' t")}`,
         MONTHLY: () => `Monthly on day ${date.toFormat("d 'at' t")}`,
         YEARLY: () => `Yearly on ${date.toFormat("MMMM d 'at' t")}`,
 })[this.frequency]();
     },
     
     
   },
   methods: {
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     },

     formatIntlNumber (input) {
       const phoneNumber = parsePhoneNumberFromString(input)
       return phoneNumber.formatInternational()
     },

     parseNote (n) {
       return parse(n)
     },
   }
 }
</script>


<style>
 .query-name .CodeMirror {
   font-size: 15px;
   padding: 3px 4px;
   background: #000;
   color: #fff;
   border-radius: 0;
   border-left: 4px solid #fff;
 }
</style>
